import React, { Component } from 'react';
import PropTypes from 'prop-types';
// ---
import Wrapper from '../../components/wrapper';
// ---
import { WINDOW } from '../../constants/environment'
// ---
import './styles.css';
import ScrollLoader from '../../components/scroll-loader';

// ---------------------------------------
/**
 * description 出力タグを作成します
 * @param {?string} description HTML description
 * @param {string} [suffix=''] pc | mb
 * @param {string} [baseClass=FullWidth__wysiwyg] 基準 class name
 * @returns {?ReactElement} `div.FullWidth__wysiwyg-[pc|mn]`
 * @constructor
 */
const DescriptionTag = ({ description, suffix, baseClass }) => {
  if (!description) {
    return null;
  }
  return (
    <div
      className={`${baseClass}${(suffix) ? '-': ''}${suffix}` + ' Wysiwyg'}
      dangerouslySetInnerHTML={{__html: description}}
    />
  );
};

DescriptionTag.propTypes = {
  description: PropTypes.string,
  suffix: PropTypes.string,
  baseClass: PropTypes.string,
};

DescriptionTag.defaultProps = {
  description: null,
  suffix: '',
  baseClass: 'FullWidth__wysiwyg',
};
// ---------------------------------------
export default class FullWidth extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    pcImageSrc: PropTypes.string,
    mbImageSrc: PropTypes.string,
    pcVideoSrc: PropTypes.string,
    mbVideoSrc: PropTypes.string,
    pcVerticalSize: PropTypes.string,
    mbVerticalSize: PropTypes.string,
    parallax: PropTypes.bool,
    effect: PropTypes.string,
    pcDescription: PropTypes.string,
    mbDescription: PropTypes.string,
    pcPosition: PropTypes.string,
    mbPosition: PropTypes.string,
    photoInfo: PropTypes.arrayOf(PropTypes.node),
    link: PropTypes.shape({
      href: PropTypes.string,
      targetBlank: PropTypes.bool,
    })
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    pcImageSrc: null,
    mbImageSrc: null,
    pcVideoSrc: null,
    mbVideoSrc: null,
    pcVerticalSize: null,
    mbVerticalSize: null,
    parallax: null,
    effect: 'Light-To-Dark',
    pcDescription: null,
    mbDescription: null,
    pcPosition: null,
    mbPosition: null,
    photoInfo: null,
    link: null,
  };
  /**
   * parallax flag true: class - `FullWidth__parallax`
   * @type {string}
   */
  static PARALLAX = 'FullWidth__parallax';
  /**
   * parallax fixed class - `FullWidth__parallax__fixed`
   * @type {string}
   */
  static FIXED = 'FullWidth__parallax__fixed';
  /**
   * parallax 背景 bottom class - `FullWidth__parallax__bottom`
   * @type {string}
   */
  static BOTTOM = 'FullWidth__parallax__bottom';

  /**
   * opacity 0 にする class name
   * @type {string}
   */
  static OPACITY_ZERO = 'FullWidth__opacity__zero';

  /**
   * props.effect を起動する class name
   * @type {string}
   */
  static PARALLAX_ACTION = 'FullWidth__parallax__action';

  static SCROLL_DOWN = 'scrollDown';
  static SCROLL_UP = 'scrollUp';

  constructor(props) {
    super(props);
    // ---
    /**
     * HTML5 video tag
     * @type {{pc: ?Element, mb: ?Element}}
     */
    this.videos = {
      pc: null,
      mb: null,
    };
    /**
     * HTML5 video ended flag
     * @type {{pc: boolean, mb: boolean}}
     */
    this.ended = {
      pc: false,
      mb: false,
    };
    /**
     * bound onPcPlay - pc.video.play event handler
     * @type {bound|any}
     */
    this.onPcPlay = this.onPcPlay.bind(this);
    /**
     * bound onMbPlay - mb.video.play event handler
     * @type {bound|any}
     */
    this.onMbPlay = this.onMbPlay.bind(this);

    /**
     * play flag
     * @type {{pc: boolean, mb: boolean}}
     */
    this.playing = {
      pc: false,
      mb: false,
    };
    // timer id
    this.timer = {
      pc: 0,
      mb: 0,
      opacityComplete: 0,
    };
    /**
     * bind onScroll - window.onscroll\onresize event handler
     * @type {bound|any}
     */
    this.onScroll = this.onScroll.bind(this);
    /**
     * window.onresize event handler
     * @type {bound|any}
     */
    this.onResize = this.onResize.bind(this);

    const {
      pcVideoSrc,
      mbVideoSrc,
    } = props;
    const pcSrc = pcVideoSrc || '';
    const mbSrc = mbVideoSrc || pcSrc;
    /**
     * React.state
     * - visiblePc {boolean} - pc video visible flag
     * - visibleMb {boolean} - mb video visible flag
     * - fixed {string} - parallax fixed class
     * - bottom {string} - parallax bottom class
     * @type {{
     *  visiblePc: boolean,
     *  visibleMb: boolean,
     *  fixed: string,
     *  bottom: string,
     *  opacity: number,
     *  translateY: number,
     *  mbAspect: Object,
     *  opacityZero: ?string,
     *  parallaxAction: ?string,
     *  directionChange: boolean,
     * }}
     */
    this.state = {
      visiblePc: !!pcSrc,
      visibleMb: !!mbSrc,
      fixed: '',
      bottom: '',
      // overlay opacity 0 to .77
      // opacity: 0,
      // `.FullWidth__figure` transform
      translateY: 0,
      // ---
      mbAspect: { opacity: 0 },
      // ===
      opacityZero: FullWidth.OPACITY_ZERO,
      parallaxAction: '',
      // ---
      scrollDirection: FullWidth.SCROLL_DOWN,
    };
    this.figureBlock = null;
    this.isParallax = props.parallax;
    /**
     * element reference
     * - figure - `.FullWidth__figure`
     * - container - `.FullWidth__container`
     * @type {{figure: ?Element, container: ?Element}}
     */
    this.elements = {
      figure: null,
      container: null,
      // root: null,
    };
    /**
     * scroll 監視開始 flag
     * @type {boolean}
     */
    this.watched = false;
    /**
     * 前回 scroll 位置
     * @type {number}
     */
    this.y = -1;
    /**
     * offset value - future need
     * @type {number}
     */
    this.offset = 0;
    /**
     * 定数 - 最大透明度
     * @type {number}
     */
    this.opacityMax = 1 / 1.5;
    this.onShouldPlay = this.onShouldPlay.bind(this);
    /**
     * PC - video.onCanPlay handler - 未使用
     * @deprecated - 使用しない
     * @type {bound|any}
     */
    this.onPcCanPlay = this.onPcCanPlay.bind(this);
    /**
     * MB - video.onCanPlay handler
     * @type {bound|any}
     */
    this.onMbCanPlay = this.onMbCanPlay.bind(this);
    /**
     * video.onCanPlay flag
     * - pc - 未使用
     * @type {{pc: boolean, mb: boolean}}
     */
    this.canPlay = {
      pc: false,
      mb: false,
    };
    // ---
    /**
     * default opacity 0 - 表示位置で fadein の duration 3000ms
     * - .FullWidth__parallax__action - transition-duration: 3000ms;
     * @type {number}
     * @default 3000
     */
    this.fadeInDuration = 3000;
    /**
     * default opacity 0 - 表示位置で fadein complete flag
     * - fadein complete まで props.effect 発動しない
     * @type {boolean}
     * @default false
     */
    this.fadeInCompleted = false;
    // ---
    // Dark-To-Light / Light-To-Dark - effect class name
    // scroll down - prop.effect || Light-To-Dark
    // scroll up - prop.effect ではない方
    /**
     * scroll direction flag - effect class select に使用します
     * - false: scroll down
     * - true: scroll up
     * @type {boolean}
     */
    this.reversed = false;
    const defaultEffectClass = 'Light-To-Dark';
    const reverseClasses = {
      'Dark-To-Light': `FullWidth__${defaultEffectClass.toLowerCase()}`,
      'Light-To-Dark': `FullWidth__${'Dark-to-Light'.toLowerCase()}`,
    };
    /**
     * props.effect を元に設定 scroll down class name を作成します
     * @type {string}
     */
    this.effectClass = `FullWidth__${(props.effect || defaultEffectClass).toLowerCase()}`;
    /**
     * props.effect を元に設定 scroll up class name を作成します
     * @type {string}
     */
    this.reverseClass = reverseClasses[props.effect] || reverseClasses[defaultEffectClass];
    // console.log('FullWidth', props.containerId, this.effectClass, this.reverseClass);
    this.scrollDirection = FullWidth.SCROLL_DOWN;
    this.scrolled = 0;
    // // ---
    // this.onTouchTriggerPlayVideo = this.onTouchTriggerPlayVideo.bind(this);
    // this.touchEvents = [
    //   'touchstart',
    //   'touchmove',
    //   'touchend',
    //   'touchcancel',
    //   'click',
    // ];
    // ---
    /**
     * CMS iframe flag
     * @type {boolean}
     * @default false
     */
    this.inEpi = false;
  }
  // /**
  //  * touch event を delegate して Android で autoplay できないやつを play する
  //  */
  // onTouchTriggerPlayVideo() {
  //   // const video = this.videos.mb;
  //   // const playing = this.playing.mb;
  //   // if (video && !playing && this.hitTest()) {
  //   //   // console.log('Video.onTouchTriggerPlayVideo', video.paused, playing);
  //   //   this.playVideo(false);
  //   // }
  //   // console.log('FullWidth.onTouchTriggerPlayVideo', this.videos.mb.paused, this.playing.mb);
  //   if (this.videos.mb.paused) {
  //     this.playVideo(false);
  //   }
  // }
  /**
   * @deprecated - not use
   */
  onPcCanPlay() {
    if (this.isParallax || this.canPlay.pc) {
      return;
    }
    this.canPlay.pc = true;
    this.videoDimensions(true)
  }

  /**
   * mb - video.onCanPlay handler
   * - {@link FullWidth.isParallax}.mb を true 設定します
   * - {@link FullWidth.videoDimensions} 実行します
   */
  onMbCanPlay() {
    if (this.isParallax || this.canPlay.mb) {
      return;
    }
    this.canPlay.mb = true;
    this.videoDimensions(false)
  }
  
  /**
   * pc: video.play event handler
   * - timer clear
   * - playing flag true
   */
  onPcPlay() {
    clearTimeout(this.timer.pc);
    this.playing.pc = true;
  }
  
  /**
   * mb: video.play event handler
   * - timer clear
   * - playing flag true
   */
  onMbPlay() {
    clearTimeout(this.timer.mb);
    this.playing.mb = true;
    // this.disposeTouches();
  }
  
  // ---------------------------------------
  /**
   * window.onresize|onscroll event handler
   * - {@link FullWidth.checkShouldPlay} を実行します - 見えたら再生を判定後実行します
   */
  onShouldPlay() {
    this.checkShouldPlay();
  }
  
  /**
   * 見えたら再生のための event watch
   */
  activateShouldPlay() {
    this.disposeShouldPlay();
    window.addEventListener('resize', this.onShouldPlay, false);
    window.addEventListener('scroll', this.onShouldPlay, false);
  }
  
  /**
   * 見えたら再生のための event unwatch
   */
  disposeShouldPlay() {
    window.removeEventListener('resize', this.onShouldPlay);
    window.removeEventListener('scroll', this.onShouldPlay);
  }
  // disposeTouches() {
  //   this.touchEvents.map(type => (window.removeEventListener(type, this.onTouchTriggerPlayVideo)));
  // }
  /**
   * 見えたら再生範囲に入っているかをチェックします
   */
  checkShouldPlay() {
    const { figure } = this.elements;
    if (!figure) {
      return;
    }
    const rect = figure.getBoundingClientRect();
    const { top, bottom } = rect;
    const innerHeight = window.innerHeight;
    // console.log('FullWidth.checkShouldPlay', this.props.containerId, top, bottom, innerHeight);
    if (
      (top >= 0 && top <= innerHeight) ||
      (bottom >= 0 && bottom <= innerHeight)
    ) {
      // 表示エリアに入った
      this.playVideos();
    } else if (bottom < 0 || top > innerHeight) {
      // 見切れている
      // pause + rewind
      this.pauseVideos();
      this.rewindVideos();
    }
  }
  
  // ---------------------------------------
  /**
   * window.onresize event handler
   * - {@link FullWidth.scrolling} scroll ip / down 判定を行います
   */
  onResize() {
    this.scrolling();
  }
  
  /**
   * window.onscroll event handler
   * - {@link FullWidth.scrolling} scroll ip / down 判定を行います
   */
  onScroll() {
    this.scrolling();
  }
  
  /**
   * scroll 監視を始めます
   * - {@link FullWidth.scrolling} 実行します
   */
  watchScroll() {
    if (this.watched) {
      return;
    }
    this.watched = true;
    window.addEventListener('scroll', this.onScroll, false);
    this.scrolling();
  }
  
  /**
   * scroll 監視を止めます
   */
  unwatchScroll() {
    window.removeEventListener('scroll', this.onScroll);
    this.watched = false;
  }
  
  /**
   * container / figure ClientRect を取得します
   * @returns {{container: ({bottom, height, left, right, top, width}|*|ClientRect|DOMRect), figure: ({bottom, height, left, right, top, width}|*|ClientRect|DOMRect)}}
   */
  getRectContainerWithFigure() {
    const { container, figure } = this.elements;
    return {
      container: container.getBoundingClientRect() || null,
      figure: figure.getBoundingClientRect() || null,
    };
  }
  
  /**
   * container ClientRect を取得します - `.FullWidth__container`
   * @returns {{bottom, height, left, right, top, width}|*|ClientRect|DOMRect}
   */
  getContainerRect() {
    if (this.elements && this.elements.container && this.elements.container.getBoundingClientRect) {
      return this.elements.container.getBoundingClientRect();
    } else {
      return null;
    }
  }
  
  // /**
  //  * scroll 監視が必要かをチェックします
  //  * - container height が小さいと何もしなくて構わない
  //  * @returns {boolean} true: 必要
  //  */
  // checkActivationParallax() {
  //   const { parallax } = this.props;
  //   if (!parallax) {
  //     return false;
  //   }
  //   const { container, figure } = this.elements;
  //   if (!container || !figure) {
  //     return false;
  //   }
  //   const rect = this.getRectContainerWithFigure();
  //   // contents container が大きいことが条件
  //   return rect.figure.height <= rect.container.height;
  // }

  // containerBiggerThanFigure() {
  //   const { container, figure } = this.elements;
  //   if (!container || !figure) {
  //     return false;
  //   }
  //   const rect = this.getRectContainerWithFigure();
  //   // contents container が大きいことが条件
  //   return rect.figure.height <= rect.container.height;
  // }
  
  /**
   * scroll 処理 - up / down で分岐します
   * - down - {@link FullWidth.parallaxScrollDown}
   * - up - {@link FullWidth.parallaxScrollUp}
   */
  scrolling() {
    // const activateParallax = this.checkActivationParallax();
    const y = window.pageYOffset;
    const move = this.y - y;
    if (!move) {
      return;
    }
    this.y = y;
    // console.log('FullWidth.scrolling - move', this.props.containerId, move);
    if (move < 0) {
      this.parallaxScrollDown(move);
    } else {
      this.parallaxScrollUp(move);
    }
    this.checkFullWidthFadeIn(move);
  }

  /**
   * fadein duration 後の timeout 処理で {@link FullWidth.fadeInCompleted} flag を true にします
   * - {@link FullWidth.fadeInCompleted} が true になるまで `props.effect` action は実行されません
   */
  fadeInStart() {
    clearTimeout(this.timer.opacityComplete);
    this.setState({ opacityZero: '' });
    this.timer.opacityComplete = setTimeout(() => {
      this.fadeInCompleted = true;
    }, this.fadeInDuration);
  }

  /**
   * {@link FullWidth.getContainerRect} `.FullWidth__container`.clientRect を取得し fade 開始するか否かを判断し実行します
   * @param {number} move scroll 量 - 正・負で方向を知ります, 負: scroll down
   */
  checkFullWidthFadeIn(move) {
    if (!this.state.opacityZero) {
      return;
    }
    const height = window.innerHeight;
    const half = height * 0.5;
    const containerRect = this.getContainerRect();
    if (!containerRect) return;
    const middle = containerRect.height * 0.5;
    if (move < 0) {
      // scroll up
      if ((containerRect.top <= half || (containerRect.top + middle) <= height) && containerRect.bottom > 0) {
        this.fadeInStart();
      }
    } else if (containerRect.bottom >= half && containerRect.top < height) {
      // scroll down
      this.fadeInStart();
    }
  }
  
  // /**
  //  * `.FullWidth__figure__parallax__overlay` opacity を計算します
  //  * @param {ClientRect} container `div.FullWidth__container` bounding box values
  //  */
  // overlayOpacityByScroll(container) {
  //   const { top, height } = container;
  //   const distance = (Math.abs(top) - this.offset) / height * 3.333;
  //   const opacity = (distance < this.opacityMax) ? distance: this.opacityMax;
  //   if (this.state.opacity !== opacity) {
  //     this.setState({ opacity });
  //   }
  // }
  
  /**
   * `.FullWidth__figure` parallax delay scroll down
   * @param {ClientRect} container `div.FullWidth__container` bounding box values
   * @param {number} innerHeight window.innerHeight
   */
  slowParallaxScrollDown(container, innerHeight) {
    const { bottom } = container;
    const translateY = (innerHeight - bottom) * 0.5;
    if (this.state.translateY !== translateY) {
      this.setState({ translateY });
    }
  }
  
  /**
   * `.FullWidth__figure` parallax delay scroll up
   * @param {ClientRect} container `div.FullWidth__container` bounding box values
   * @param {number} innerHeight window.innerHeight
   */
  slowParallaxScrollUp(container, innerHeight) {
    const { bottom } = container;
    const translateY = (innerHeight - bottom) * 0.5;
    // console.log('FullWidth.slowParallaxScrollUp', translateY);
    if (translateY >= 0) {
      if (this.state.translateY !== translateY) {
        this.setState({ translateY });
      }
    } else if (this.state.translateY) {
      this.setState({ translateY: 0 });
    }
  }

  /**
   * parallax light-to-dark / dark-to-light transition クラスを `state` に追加し開始します
   */
  activateParallaxAction() {
    if (this.state.parallaxAction) {
      return;
    }
    this.setState({ parallaxAction: FullWidth.PARALLAX_ACTION });
  }

  /**
   * parallax light-to-dark / dark-to-light off にします
   */
  abortParallaxAction() {
    if (!this.state.parallaxAction) {
      return;
    }
    this.setState({ parallaxAction: '' });
  }

  /**
   * @deprecated instead use {@link FullWidth.parallaxScrollColorTransition}
   * @param {ClientRect} containerRect - `.FullWidth__container` rectangle parameter
   * @param {number} height - window.innerHeight
   */
  parallaxScrollDownAction(containerRect, height) {
    const half = height * 0.5;
    const middle = containerRect.height * 0.5;
    if ((containerRect.top <= half || (containerRect.top + middle) <= height) && containerRect.bottom > 0) {
      this.activateParallaxAction();
    } else if (containerRect.bottom < 0) {
      this.abortParallaxAction();
    }
  }
  /**
   * @deprecated instead use {@link FullWidth.parallaxScrollColorTransition}
   * @param {ClientRect} containerRect - `.FullWidth__container` rectangle parameter
   * @param {number} height - window.innerHeight
   */
  parallaxScrollUpAction(containerRect, height) {
    const half = height * 0.5;
    if (containerRect.bottom >= half && containerRect.top < height) {
      this.activateParallaxAction();
    } else if (containerRect.top > height) {
      this.abortParallaxAction();
    }
  }

  parallaxScrollColorTransitionScrollDown(containerRect, innerHeight) {
    const { top } = containerRect;
    const middle = innerHeight * 0.5;
    const absTop = Math.abs(top);
    if (top < 0 && absTop >= middle) {
      this.activateParallaxAction();
    }
  }
  parallaxScrollColorTransitionScrollUp(containerRect, innerHeight) {
    const { bottom } = containerRect;
    const middle = innerHeight * 0.5;
    if (bottom >= (innerHeight + middle)) {
      this.activateParallaxAction();
    }
  }
  /**
   * ▽FullWidthブロック自体のフェードイン効果
   * ・FullWidthブロックはデフォルト非表示（visibility:hidden (or/and opacity:0)で領域は確保したまま。ブロック全体を透過させて、親要素の背景色が反映されるようにする）
   * ・特定位置までスクロールすると（すでに実装いただいている動画開始と同じところで）フェードイン開始
   * ・はじめに背景イメージがフェードイン、少し遅れてテキストやボタン等の要素がフェードイン
   *
   * ▽背景画像が暗く／明るくなる効果
   * ・スクロール量に合わせて明度が変わるのではなく、一定の高さになったらフェードする（on/offする）ように変更いただきたいです
   * ・一定の高さ：FullWidthブロックが画面状態に達してから、ウィンドウの高さの半分がスクロールされたら
   *
   *
   * 背景が明るく/暗くなるのは、FullWidthがフェードインして、画面上端でロックされて、さらに一定量のスクロールを行った後、になります。
   * @param {ClientRect} containerRect - `.FullWidth__container` rectangle parameter
   * @param {number} innerHeight - window.innerHeight
   * @param {boolean} [up=false] scroll direction - true: scroll up
   */
  parallaxScrollColorTransition(containerRect, innerHeight, up = false) {
    const { top, bottom } = containerRect;
    // const middle = innerHeight * 0.5;
    // const absTop = Math.abs(top);

    if (bottom < 0 || top > innerHeight || !this.fadeInCompleted) {
      // 見切れている
      // fadein transition が終わっていない
      if (bottom < 0) {
        this.reversed = true;
      } else if (top > innerHeight) {
        this.reversed = false;
      }
      this.abortParallaxAction();
    } else if (!up) {
      this.parallaxScrollColorTransitionScrollDown(containerRect, innerHeight);
    } else if (up) {
      this.parallaxScrollColorTransitionScrollUp(containerRect, innerHeight);
    }
    // else if (!up && top < 0 && (absTop >= middle)) {
    //   // scroll down
    //   // console.log('FullWidth.parallaxScrollColorTransition --- scroll down', this.props.containerId, up, absTop, innerHeight, middle, containerRect);
    //   this.activateParallaxAction();
    // } else if (up && (bottom >= (innerHeight + middle))) {
    //   // scroll up
    //   // console.log('FullWidth.parallaxScrollColorTransition --- scroll up', this.props.containerId, up, bottom, innerHeight, middle, containerRect);
    //   this.activateParallaxAction();
    // }
  }
  /**
   * scroll down 処理
   * @param {number} move scroll 量 - 正・負で方向を知ります, 負: scroll down
   */
  parallaxScrollDown(move) {
    const { parallax } = this.props;
    if (!parallax) {
      return;
    }
    const containerRect = this.getContainerRect();
    if (!containerRect) return;
    const height = window.innerHeight;
    const threshold = height * 0.5;
    // ---
    // scroll 量
    if (this.scrollDirection !== FullWidth.SCROLL_DOWN) {
      this.scrollDirection = FullWidth.SCROLL_DOWN;
      this.scrolled = 0;
    }
    this.scrolled += Math.abs(move);
    if (this.scrolled >= threshold && this.state.scrollDirection !== this.scrollDirection) {
      this.reversed = false;
      this.setState({ scrollDirection: this.scrollDirection });
    }
    // ---
    this.parallaxScrollColorTransition(containerRect, height, false);
    // container bottom が window height より小さい -> 上に来ている -> container bottom へ貼り付ける
    const needBottom = containerRect.bottom <= height;
    const needUpdateBottom = needBottom && this.state.bottom !== FullWidth.BOTTOM;
    // console.log('FullWidth.parallaxScrollDown', height, containerRect, needBottom, needUpdateBottom);
    if (needUpdateBottom) {
      return this.setState({ fixed: '', bottom: FullWidth.BOTTOM });
    } else if (needBottom) {
      if (containerRect.bottom >= 0) {
        this.slowParallaxScrollDown(containerRect, height);
      } else {
        this.setState({ translateY: null });
      }
      return;
    }
    // -------------------------------------------
    
    // ------ window.top(0) + this.offset
    //
    //   ****** container.top
    //
    // ------ window.bottom - window.innerHeight
    // ---
    // this.overlayOpacityByScroll(container);
    // ---
    const needFixed = containerRect.top <= this.offset;
    const needUpdateFixed = needFixed && this.state.fixed !== FullWidth.FIXED;
    // console.log('FullWidth.parallaxScrollDown', height, rect, needBottom, needUpdateBottom);
    if (needUpdateFixed) {
      this.setState({ fixed: FullWidth.FIXED, bottom: '' });
    }
  }
  
  /**
   * scroll up 処理
   * @param {number} move scroll 量 - 正・負で方向を知ります, 負: scroll down
   */
  parallaxScrollUp(move) {
    const { parallax } = this.props;
    if (!parallax) {
      return;
    }
    const containerRect = this.getContainerRect();
    if (!containerRect) return;
    const height = window.innerHeight;
    const threshold = height * 0.5;
    // ---
    // scroll 量
    if (this.scrollDirection !== FullWidth.SCROLL_UP) {
      this.scrollDirection = FullWidth.SCROLL_UP;
      this.scrolled = 0;
    }
    this.scrolled += Math.abs(move);
    if (this.scrolled >= threshold && this.state.scrollDirection !== this.scrollDirection) {
      this.reversed = true;
      this.setState({ scrollDirection: this.scrollDirection });
    }
    // ---
    // this.parallaxScrollUpAction(containerRect, height);
    this.parallaxScrollColorTransition(containerRect, height, true);
    // ---
    const needFree = containerRect.top >= this.offset;
    const needUpdateFree = needFree && (this.state.bottom !== '' || this.state.fixed !== '');
    // console.log('FullWidth.parallaxScrollUp', needUpdateFree, needFree);
    if (needUpdateFree) {
      const nextState = { fixed: '', bottom: '' };
      if (this.state.translateY) {
        nextState.translateY = 0;
      }
      return this.setState(nextState);
    } else if (needFree) {
      return;
    }
    // ---
    if (containerRect.bottom >= 0) {
      this.slowParallaxScrollUp(containerRect, height);
    }
    // ---
    const needFixed = containerRect.bottom >= height;
    const needUpdateFixed = needFixed && this.state.fixed !== FullWidth.FIXED;
    if (needUpdateFixed) {
      this.setState({ fixed: FullWidth.FIXED, bottom: '' });
    }
  }
  /**
   * 強制実行します
   */
  fireScrollEvent() {
    this.parallaxScrollDown();
  }
  // ---------------------------------------
  /**
   * alignment - position class name を生成します
   * @returns {{pc: string, mb: string}} alignment - position class name
   */
  alignmentPosition() {
    const {
      pcPosition,
      mbPosition,
    } = this.props;
    const pc = `pcPosition__${(pcPosition || 'Center-Upper').toLowerCase()}`;
    const mb = `mbPosition__${(mbPosition || 'Upper').toLowerCase()}`;
    return { pc, mb };
  }
  /**
   * vertical size class name を生成します
   * @returns {{pc: string, mb: string, parallax: string}} vertical size class name
   */
  verticalSizeClassName() {
    const {
      pcVerticalSize,
      mbVerticalSize,
      parallax,
    } = this.props;
    const pc = `pcVerticalSize__${(pcVerticalSize || 'Medium').toLowerCase()}`;
    const mb = `mbVerticalSize__${(mbVerticalSize || 'Medium').toLowerCase()}`;
    return {
      pc,
      mb,
      parallax: (parallax && !this.inEpi) ? FullWidth.PARALLAX: '',
    };
  }
  // --------------------------------------------------------
  // video control
  /**
   * video tag muted property を true 設定します
   * - video.mute が有効にならないので property 設定します
   */
  videoMute() {
    Object.values(this.videos).map(video => {
      if (video) {
        video.muted = true;
        video.defaultMuted = true;
      }
      return video;
    });
  }
  /**
   * video.play success 処理
   * - playing flag true
   * @param {boolean} pc video file select flag - true: PC
   */
  playSuccess(pc) {
    if (pc) {
      this.playing.pc = true;
    } else {
      this.playing.mb = true;
    }
  }
  // -----------------------------------------------------
  /**
   * error message より　`video` 非表示実行します
   * - no supported source - 404, ...etc
   * - didn't interact - have to touch
   * @param {boolean} pc video file select flag - true: PC
   * @param {Error} error video play error message
   * @returns {boolean} true - 非表示実行
   */
  needHideVideo(pc, error) {
    if (!error || !error.message) {
      // console.warn('FullWidth.needHideVideo error not found', pc, error);
      return false;
    }
    // 404: ~ no supported source ~
    // touch first: failed because the user didn't interact with the document first
    const massages = [
      'no supported source',
      'interact with',
    ];
    const result = massages.some(message => (error.message.indexOf(message) !== -1));
    // console.log('FullWidth.needHideVideo result', pc, result, error.message);
    if (result) {
      const state = pc ? { visiblePc: false } : { visibleMb: false };
      this.setState(state);
      return true;
    }
    return false;
  }
  /**
   * {@link FullWidth.needHideVideo} - error message より　`video` 非表示実行します
   * - no supported source - 404, ...etc
   * - didn't interact - have to touch
   * 戻り値 `false` - 非表示にならない時は 1frame に移動して止める
   * @param {boolean} pc video file select flag - true: PC
   * @param {Error} [error=null] video play error message
   */
  playFaultAlternateImage(pc, error = null) {
    // console.log('Video.playFaultAlternateImage', pc, this.posters);
    if (this.needHideVideo(pc, error)) {
      return;
    }
    this.pauseVideo(pc);
    this.rewindVideo(pc);
  }
  /**
   * video.play fault 処理
   * - visible flag を false にし非表示にします
   * @param {boolean} pc video file select flag - true: PC
   * @param {Error} [error=null] video play error message
   */
  playFault(pc, error = null) {
    this.playFaultAlternateImage(pc, error);
  }
  /**
   * HTML5 video 再生します
   * - 再生失敗した時は非表示実行します
   * @param {boolean} pc desktop flag
   */
  playVideo(pc) {
    const video = (pc) ? this.videos.pc: this.videos.mb;
    // const playing = (pc) ? this.playing.pc: this.playing.mb;
    const ended = pc ? this.ended.pc : this.ended.mb;
    const { visiblePc, visibleMb } = this.state;
    const visible = (pc) ? visiblePc: visibleMb;
    // console.log('FullWidth.playVideo', pc, video, playing, visible);
    if (!video || !visible || ended) {
      return;
    }
    if (!video.paused) {
      return;
    }
    let playPromise = null;
    try {
      playPromise = video.play();
      this.playSuccess(pc);
    } catch (e) {
      console.warn(`[FullWidth] play video fault - pc: ${pc}, ${error}`);
      this.playFault(pc, e);
    }
    if (playPromise) {
      playPromise.catch((error) => {
        console.warn(`[FullWidth] play video fault in Promise - pc: ${pc}, ${error}`);
        this.playFault(pc, error);
      });
    }
  }
  /**
   * video 再生します
   */
  playVideos() {
    // pc
    this.playVideo(true);
    // mb
    this.playVideo(false);
  }
  /**
   * video tag - pause 実行します
   * @param {boolean} pc desktop flag
   */
  pauseVideo(pc) {
    const video = (pc) ? this.videos.pc: this.videos.mb;
    const playing = (pc) ? this.playing.pc: this.playing.mb;
    const { visiblePc, visibleMb } = this.state;
    const visible = (pc) ? visiblePc: visibleMb;
    // console.log('FullWidth.playVideo', pc, video, playing, visible);
    if (!video || !playing || !visible) {
      return;
    }
    // status check - 2018-10-31
    if (video.paused) {
      return;
    }
    // ---
    try {
      video.pause();
    } catch (error) {
      console.warn(`[FullWidth].pauseVideo fault - pc: ${pc}, ${error}`, video.src);
      // this.playFault(pc);
    }
    // if (pc) {
    //   this.playing.pc = false;
    // } else {
    //   this.playing.mb = false;
    // }
  }
  /**
   * video pause - (pc / mb)
   */
  pauseVideos() {
    // pc
    this.pauseVideo(true);
    // mb
    this.pauseVideo(false);
  }
  /**
   * rewind します
   * @param {boolean} pc desktop flag
   */
  rewindVideo(pc) {
    const video = (pc) ? this.videos.pc: this.videos.mb;
    const { visiblePc, visibleMb } = this.state;
    const visible = (pc) ? visiblePc: visibleMb;
    // console.log('FullWidth.playVideo', pc, video, playing, visible);
    if (!video || !visible) {
      return;
    }
    // 再生中は rewind しない
    if (!video.paused) {
      return;
    }
    // ---
    try {
      video.currentTime = 0;
    } catch (e) {
      console.warn('[FullWidth].rewindVideo', pc, video.src, e);
    }
  }
  /**
   * 1 frame 目に戻す(rewind) - (pc / mb)
   */
  rewindVideos() {
    // pc
    this.rewindVideo(true);
    // mb
    this.rewindVideo(false);
  }
  // --------------------------------------------------------
  /**
   * event を unbind します - parallax
   */
  abortWatchResize() {
    window.removeEventListener('resize', this.onResize);
  }
  
  /**
   * event 監視を有効にします - parallax
   */
  activateWatchResize() {
    this.abortWatchResize();
    window.addEventListener('resize', this.onResize, false);
  }
  // --------------------------------------------------------
  /**
   * video size が css だけでは制御不可能なので JS で補助します
   * - mb だけ使用します
   * @param {boolean} mode pc / mb flag, true: pc
   */
  videoDimensions(mode) {
    const video = mode ? this.videos.pc : this.videos.mb;
    const block = this.figureBlock.getBoundingClientRect();
    const x = block.width / video.videoWidth;
    const y = block.height / video.videoHeight;
    if (x < y) {
      this.setState({ mbAspect: { height: '100%' } });
    } else {
      this.setState({ mbAspect: { width: '100%' } });
    }
  }
  
  // --------------------------------------------------------
  // CMS preview 用に parallax ON / OFF する
  activateNormalParallax() {
    this.activateWatchResize();
    this.watchScroll();
    this.fireScrollEvent();
    // -----------------------
    // 見えたら再生
    this.activateShouldPlay();
    // first check
    this.checkShouldPlay();
  }

  inIframeShowAll() {
    // this.inEpi = true;
    this.setState({ opacityZero: '', parallaxAction: FullWidth.PARALLAX_ACTION });
    this.playVideos();
  }

  // --------------------------------------------------------
  /**
   * delegate after mount
   * - playing
   */
  componentDidMount() {
    this.videoMute();
    // CMS - iframe preview へ対応する
    // ref: https://hakuhodoms.backlog.com/view/MZD_RNAL_INNER-269#comment-9536200
    if(WINDOW !== WINDOW.parent && WINDOW.parent.EPi){
      // 編集プレビュー時の処理
      //・パララックスをOFFにする（レイアウト崩れ対応）
      //・初期非表示をOFFにする（表示されない問題対応）
      setTimeout(()=> {
        this.inIframeShowAll();
      }, 200);
      // this.inIframeShowAll();
    } else {
      setTimeout(()=> {
        this.activateNormalParallax();
      }, 200);
      // this.activateNormalParallax();
    }
    // ---
    // Android `NotAllowedError: play() failed because the user didn't interact with the document first.` の対策で touch 監視して再生させる
    // if (this.videos.mb && 'ontouchstart' in document.documentElement) {
    //   this.touchEvents.map(type => (window.addEventListener(type, this.onTouchTriggerPlayVideo, false)));
    // }
  }
  /**
   * delegate - before unmount
   * - timer clear する
   */
  componentWillUnmount() {
    Object.values(this.timer).map(id => (clearTimeout(id)));
    this.abortWatchResize();
    this.unwatchScroll();
    this.disposeShouldPlay();
    // this.disposeTouches();
  }
  /**
   * HTML5 video tag を作成します
   * @param {?string} src video path
   * @param {?string} [poster=null] poster image path
   * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
   * @param {string} [baseClass=FullWidth__video] コンテナへ付与する class name 先頭文字
   * @returns {?Element} `video.FullWidth__video` tag を返します
   */
  renderVideo(src, poster = null, suffix = '', baseClass = 'FullWidth__video') {
    // 制御に必要な property が無い時は null を返す
    if (src === null || !src || !suffix) {
      return null;
    }
    // state - visible
    const { visiblePc, visibleMb, mbAspect } = this.state;
    // ---
    const isPc = (suffix === 'pc');
    const visible = isPc ? visiblePc : visibleMb;
    if (!visible) {
      if (isPc) {
        this.videos.pc = null;
      } else {
        this.videos.mb = null;
      }
      return null;
    }
    // ---
    // class name
    const className = `${baseClass} ${baseClass}${(suffix) ? '-': ''}${suffix}`;
    // video tag
    const attributes = {
      preload: 'none',
      controls: false,
      // autoPlay: true,
      playsInline: true,
      muted: true,
      loop: true,
      src,
      className,
      type: `video/${src.split('.').pop().split('?').shift()}`,
    };
    // poster 存在する時のみ
    if (poster) {
      attributes.poster = poster;
    }
    // pc / mb
    // onEnded event と ref を分けるために分岐処理する
    // - autoPlay で play させて resize 制御しないことにする
    if (suffix === 'pc') {
      attributes.ref = (component) => (this.videos.pc = component);
      attributes.onPlay = this.onPcPlay;
      attributes.style = (visiblePc) ? null : { display: 'none' };
      // attributes.onCanPlay = this.onPcCanPlay;
    } else if (suffix === 'mb') {
      let style = {};
      if (!this.isParallax) {
        style = Object.assign({}, mbAspect);
        attributes.onCanPlay = this.onMbCanPlay;
      }
      if (!visibleMb) {
        style.display = 'none';
      }
      attributes.ref = (component) => (this.videos.mb = component);
      attributes.onPlay = this.onMbPlay;
      attributes.style = style;
    }
    // tag
    // console.log('FullWidth.renderVideo attributes', suffix, attributes);
    return <video {...attributes} />;
  }
  renderFigureOverlay() {
    const { parallax } = this.props;
    // const { opacity } = this.state;
    return (parallax) ? <div className="FullWidth__figure__parallax__overlay" /> : null;
  }
  renderFigureVideo() {
    const {
      pcVideoSrc,
      mbVideoSrc,
      pcImageSrc,
      mbImageSrc,
    } = this.props;
    const pcSrc = pcVideoSrc || '';
    const mbSrc = mbVideoSrc || pcSrc;
    if (!pcSrc && !mbSrc) {
      return null;
    }
    const posterPc = pcImageSrc || '';
    const posterMb = mbImageSrc || posterPc;
    const pc = this.renderVideo(pcSrc, posterPc, 'pc');
    const mb = this.renderVideo(mbSrc, posterMb, 'mb');

    return (
      <div className="FullWidth__figure__videos">
        {pc}
        {mb}
      </div>
    );
  }
  
  renderFigureImg() {
    const {
      // pcVideoSrc,
      // mbVideoSrc,
      pcImageSrc,
      mbImageSrc,
    } = this.props;
    const posterMb = mbImageSrc || pcImageSrc;
    
    if (!pcImageSrc && !posterMb) {
      return null;
    }
    // const pcSrc = pcVideoSrc || '';
    // const mbSrc = mbVideoSrc || pcSrc;
    // state - visible
    const { visiblePc, visibleMb } = this.state;

    const pc = (pcImageSrc && !visiblePc) ?
      <div
        className="FullWidth__figure__img FullWidth__figure__img-pc"
        style={{backgroundImage: `url(${pcImageSrc})`}}
      />　:
      null;
    const mb = (posterMb && !visibleMb) ?
      <div
        className="FullWidth__figure__img FullWidth__figure__img-mb"
        style={{backgroundImage: `url(${posterMb})`}}
      />　:
      null;
    if (!pc && !mb) {
      return null;
    }
    return (
      <div className="FullWidth__figure__images">
        {pc}
        {mb}
      </div>
    );
  }
  
  renderFigure() {
    const videos = this.renderFigureVideo();
    const images = this.renderFigureImg();
    if (!videos && !images) {
      return null;
    }
    const {
      photoInfo,
    } = this.props;
    // photoInfo - arrayOf だけど出力は1件
    const PhotoInfo = (photoInfo !== null && Array.isArray(photoInfo) && photoInfo.length) ? photoInfo: [];
    const overlay = this.renderFigureOverlay();
    // ---
    const { translateY } = this.state;
    const figureArguments = (translateY) ? { style: { transform: `translateY(${translateY}px)` } } : null;
    // ---
    return (
      <div
        className="FullWidth__figure__block"
        ref={component => (this.figureBlock = component)}
      >
        <div
          className="FullWidth__figure"
          ref={component => (this.elements.figure = component)}
          {...figureArguments}
        >
          {videos}
          {images}
          {overlay}
        </div>
        {PhotoInfo}
      </div>
    );
  }
  
  renderDescription() {
    const {
      pcDescription,
      mbDescription,
    } = this.props;
    // mb - description, use pc when empty
    const mbHtml = mbDescription || pcDescription;
    const pc = <DescriptionTag description={pcDescription} suffix="pc" />;
    const mb = <DescriptionTag description={mbHtml} suffix="mb" />;
    // const pc = FullWidth.descriptionTag(pcDescription, 'pc');
    // const mb = FullWidth.descriptionTag(mbHtml, 'mb');
    if (!pc && !mb) {
      return null;
    }
    const alignment = this.alignmentPosition();
    return (
      <div
        className={`FullWidth__container ${alignment.pc} ${alignment.mb}`}
        ref={component => (this.elements.container = component)}
      >
        <div className="FullWidth__wysiwyg">
          {pc}
          {mb}
        </div>
      </div>
    );
  }
  
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      link,
    } = this.props;
    // ---
    const description = this.renderDescription();
    const figure = this.renderFigure();
    // require check
    if (!description && !figure) {
      return null;
    }
    const { pc, mb, parallax } = this.verticalSizeClassName();
    const { fixed, bottom, opacityZero, parallaxAction } = this.state;
    const effectClass = !this.reversed ? this.effectClass : this.reverseClass;
    if (link && link.href && link.href !== '' && !this.props.parallax) {
      return (
        <Wrapper
          containerId={containerId}
          containerClass={containerClass}
        >
          <div id={anchorPoint} data-anchor-name={anchorName}>
            <ScrollLoader>
              <div className={`FullWidth ${pc} ${mb} ${parallax} ${fixed} ${bottom} ${opacityZero} ${parallaxAction} ${effectClass}`}>
                <a className="FullWidth__wrapped-link" href={link.href} target={(link.targetBlank) ? '_blank' : '_self'}>
                  {figure}
                  {description}
                </a>
              </div>
            </ScrollLoader>
          </div>
        </Wrapper>
      );
    } else {
      return (
        <Wrapper
          containerId={containerId}
          containerClass={containerClass}
        >
          <div id={anchorPoint} data-anchor-name={anchorName}>
            <ScrollLoader>
              <div
                className={`FullWidth ${pc} ${mb} ${parallax} ${fixed} ${bottom} ${opacityZero} ${parallaxAction} ${effectClass}`}
              >
                {figure}
                {description}
              </div>
            </ScrollLoader>
          </div>
        </Wrapper>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/full-width/index.jsx